
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface ChecklistUpdate {
  PK: string
  SK: string
  itemId: string
  newStatus?: string
  fieldName?: string
  newValue?: any
  sectionIndex?: number
  itemIndex?: number
}

export const useBatchUpdateChecklists = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (updates: ChecklistUpdate[]) => {
      // console.log('UPDATES IN MUTATION: ', updates)
      if (updates.length === 0) return
      return axios.put(`${baseUrl}/aws/checklists/batch_update`, { updates })
    },

    // ✅ Optimistic UI Update
    onMutate: async updates => {
      // console.log('updates', updates)
      await queryClient.cancelQueries({ queryKey: ['checklists'] })

      const previousChecklists = queryClient.getQueryData(['checklists'])
      // console.log('previousChecklists', previousChecklists)

      queryClient.setQueryData(['checklists'], (old: any) => {
        if (!old) return old

        return old.map((checklist: any) => ({
          ...checklist,
          sections: checklist.sections.map((section: any) => ({
            ...section,
            items: section.items.map((item: any) => {
              const updated = updates.find(update => update.itemId === item.id)
              return updated ? { ...item, status: updated.newStatus } : item
            }),
          })),
        }))
      })

      return { previousChecklists }
    },

    // 🔥 Rollback on Error
    onError: (_, __, context) => {
      if (context?.previousChecklists) {
        queryClient.setQueryData(['checklists'], context.previousChecklists)
      }
    },
    onSuccess: ({ data }, variables) => {
      console.log('onSuccess data DEALID', data?.dealId, 'onSuccess variables', variables)
      const checklistPK = data?.dealId
      const queryKey = checklistPK ? ['checklists', `${checklistPK}`] : ['checklists']
      queryClient.setQueryData(queryKey, (old: any) => {
        // console.log('OLD QUERY DATA ', old)
        if (!old) return old

        return old.map((checklist: any) => ({
          ...checklist,
          sections: checklist.sections.map((section: any) => ({
            ...section,
            items: section.items.map((item: any) => {
              const updated = variables.find(update => update.itemId === item.id)
              return updated ? { ...item, status: updated.newStatus } : item
            }),
          })),
        }))
      })
    },
    // ✅ Refetch on Success
    onSettled: context => {
      // queryClient.invalidateQueries({ queryKey: ['checklists'] })
      console.log('CONTEXT: ', context)

      const checklistPK = context?.data?.dealId
      // console.log('CHECKLIST PK', checklistPK)
      const _queryKey = ['checklists', (context as any)?.dealId ? `DEAL_${(context as any).dealId}` : `${checklistPK}`]
      // console.log('QUERY KEY', _queryKey)

      // queryClient.invalidateQueries({ queryKey: ['checklists', context?.dealId ? `DEAL_${context.dealId}` : `${checklistPK}`] })
    },
  })
  return mutation
}
